
<button class="btn-exportCsv" (click)="exportToCsv()">
    <mat-icon>save_alt</mat-icon>&nbsp;<span>{{'export csv' | translate}}</span>
</button>     
